export const messages = {
  DOM_LOADED                : 'DOMLoaded', // Used to stop the native spinner if `DOM_CONTENT_LOADED` didn't
  DOM_CONTENT_LOADED        : 'DOMContentLoaded', // Used to stop the native spinner
  LINK_CLICK                : 'linkclick', // Triggers a new iFrame instance in the app with the provided url
  STATE_OPEN                : 'state_open',
  OPEN_DOCUMENT             : 'open_document',
  ADD_TO_CART               : 'add_to_cart', // Send every time products are added to cart
  BUY_NOW                   : 'buy_now',
  PAGE_OPENED               : 'page_opened', // Send to the iFrame the title and some other data related to the page
  SHOW_NATIVE_POPUP         : 'popup', // Send on success of forgot password form
  CLEAR_QUOTE               : 'clear_quote',
  ADD_TO_CART_REDIRECT      : 'add_to_cart_with_redirect',
  ORDER_SUCCESS             : 'order_success', // Send when place order was successful
  GO_TO_FEATURED            : 'go_to_featured', // Move the app to the featured items screen
  GO_TO_CART                : 'go_to_cart',
  CART_UPDATED              : 'cart_updated', // Send to the app1 whenever the cart/quote change
  CART_QTY_UPDATED          : 'cart_qty_updated', // Send to the app2 whenever the cart/quote change
  CHECKOUT_LOGIN            : 'checkout_login',
  AUTH_SUCCESS              : 'auth_success', // On auth success
  AUTH_ERROR                : 'auth_error', // On auth error/failure
  SESSION_SUCCESS           : 'session_success', // On force session success
  SESSION_ERROR             : 'session_error', // On force session error/failure
  SESSION_REQUEST           : 'session_request',
  SEARCH_REQUEST            : 'search_request',
  SEARCH_RESPONSE           : 'search_response',
  EMPTY_SEARCH_RESPONSE     : 'empty_search_response',
  OPEN_IN_WEBVIEW           : 'open_in_webview', // Open in generic WebView for app ^3.0.0
  OPEN_IN_BROWSER           : 'open_in_browser', // Open in external browser for app ^3.0.0
  OPEN_SCREEN               : 'open_screen',
  OPEN_PUSH_NOTIFICATION    : 'open_push_notification',
  PROCESS_PUSH_NOTIFICATION : 'process_push_notification',
  LOGIN                     : 'login',
  LOGOUT                    : 'logout',
  ORDERS_LOGIN              : 'orders_login',
  INBOX_LOGIN               : 'inbox_login',
  UNREAD_UPDATED            : 'unread_updated', // Used to update the unread notifications qty badge in the app (^3.0.0)
  UPDATE_CONTENT            : 'update_content', // When received from the app, will make a `data load` to refresh the content
  STATE_ACTIVE              : 'app_state_active',
  STATE_BACKGROUND          : 'app_state_background',
  APP_CONFIG                : 'app_config',
  ANALYTICS_TRACK           : 'analytics_track',
  // Apple Pay messages
  APPLEPAY_CHECKOUT         : 'applepay_checkout',
  APPLEPAY_START            : 'applepay_start',
  APPLEPAY_UPDATE_DETAILS   : 'applepay_update_details',
  APPLEPAY_SUCCESS          : 'applepay_success',
  APPLEPAY_CANCEL           : 'applepay_cancel',
  APPLEPAY_SHIPPING_ADDRESS : 'applepay_shipping_address',
  APPLEPAY_SHIPPING_METHOD  : 'applepay_shipping_method',
  APPLEPAY_STATUS_SUCCESS   : 'applepay_status_success',
  APPLEPAY_STATUS_FAILURE   : 'applepay_status_failure',
  SET_LANGUAGE              : 'set_language', // Set language/locale from mobile app
  PAGE_LOADING_STARTED      : 'page_loading_started', // Notify app that page is loading
}
